<template>
  <div>
    <div>
      <div
        class="video-container"
        v-if="!imageCaptureStatus"
        :style="`    
            border: 2px solid ${template.secondaryColor};
            `"
      >
        <video ref="video" autoplay playsinline style="width: 100%; height: auto"></video>
      </div>
      <canvas ref="canvas" style="display: none"></canvas>
      <img
        class="mx-auto mt-2"
        style="max-width: 90%; display: none; justify-content: center; align-items: center"
        ref="capturedImage"
        alt="Captured Image"
      />
      <button
        v-if="!imageCaptureStatus"
        class="btn-block btn-dark btn shadow-sm text-uppercase mt-3"
        :style="`
                background-color: ${template.secondaryColor}
                `"
        @click="takePicture"
      >
        <label
          :style="`
                font-weight: bold;
                color: ${template.faceBiometryGradColor ? template.faceBiometryGradColor : '#fff'}
                `"
          >{{ strings.init }}</label
        >
      </button>
      <button
        v-if="imageCaptureStatus"
        class="btn-block btn-dark btn shadow-sm text-uppercase mt-3"
        :style="`
                background-color: ${template.secondaryColor}
                `"
        @click="proceedWithPic"
      >
        <label
          :style="`
                font-weight: bold;
                color: ${template.faceBiometryGradColor ? template.faceBiometryGradColor : '#fff'}
                `"
          >{{ strings.advance }}</label
        >
      </button>
      <button
        v-if="imageCaptureStatus"
        @click="takeAnotherPic"
        class="btn text-white mx-auto btn-block text-uppercase mt-3"
        style="
          text-decoration: underline;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
        "
      >
        {{ strings.anotherPic }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Camera',
  data() {
    return {
      stream: null,
      imageCaptureStatus: false,
      strings: {
        init: 'Iniciar Captura',
        advance: 'Avançar',
        anotherPic: 'Tirar outra foto',
      },
      imgUrl: null,
      img: null,
    }
  },
  computed: {
    ...mapState(['template']),
  },
  methods: {
    startCamera() {
      navigator.mediaDevices
        .getUserMedia({
          video: {
            facingMode: {
              ideal: 'user',
            },
            width: {
              ideal: 1080,
            },
            height: {
              ideal: 720,
            },
          },
          audio: false,
        })

        .then(stream => {
          this.stream = stream
          this.$refs.video.srcObject = stream
        })
        .catch(error => {
          alert('Erro ao acessar a câmera:', error)
        })
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop())
        this.$refs.video.srcObject = null
      }
    },
    async takePicture() {
      this.imageCaptureStatus = true
      const video = this.$refs.video
      const canvas = this.$refs.canvas
      const context = canvas.getContext('2d')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      context.drawImage(video, 0, 0, canvas.width, canvas.height)
      const imageUrl = canvas.toDataURL('image/png')
      this.imgUrl = imageUrl
      this.$refs.capturedImage.src = imageUrl
      this.$refs.capturedImage.style.display = 'block'
      this.img = this.imgUrl
      this.$emit('pic-taken', true)
    },
    takeAnotherPic() {
      this.imageCaptureStatus = false
      this.$emit('pic-taken', false)
      this.$refs.capturedImage.src = null
      this.$refs.capturedImage.style.display = 'none'
      this.startCamera()
    },
    proceedWithPic() {
      this.$emit('proceed-with-pic', this.img)
    },
  },
  mounted() {
    this.startCamera()
  },
  beforeDestroy() {
    this.stopCamera()
  },
  watch: {
    imageCaptureStatus(newValue) {
      if (newValue === true) {
        this.$refs.video.style.display = 'none'
      } else {
        this.$refs.video.style.display = 'block'
      }
    },
  },
}
</script>

<style>
.video-container {
  margin-block: 2rem;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  justify-self: center;
  margin-inline: auto;
}

.video-container video {
  width: 100%;
  height: auto;
  object-fit: cover; /* para garantir que o vídeo se ajuste ao contêiner */
  display: block;
}
</style>
